package org.mkui.graphics.colortheme

import org.mkui.color.MkColor
import org.mkui.color.MkColorFactory
import org.mkui.color.brightenAndSaturate
import org.mkui.color.colorOf
import org.mkui.palette.FixedPalette
import org.mkui.palette.InterpolatedPalette

class LightColorTheme() : AbstractColorTheme() {
    override val probing: MkColor
    override val selection: MkColor
    override var background: MkColor = MkColorFactory.instance.white
    set(value) {}
    override val foreground: MkColor
    override val text: MkColor
    override val palette: InterpolatedPalette
    override val ghostedPalette: FixedPalette
    override val visiblePalette: FixedPalette
    override val selectedPalette: FixedPalette
    override val selectedShadowPalette: FixedPalette
    override val isDark: Boolean
        get() = false

    override fun toString(): String {
        return "Light"
    }

    init {
        probing = colorOf(255, 200, 0)
        selection = colorOf(255, 0, 0)
        foreground = colorOf(235, 235, 235)
        text = MkColorFactory.instance.black

        palette = InterpolatedPalette(FixedPalette(MkColorFactory.instance.white, MkColorFactory.instance.black))
        ghostedPalette = FixedPalette(
            -394759,
            -789517,
            -789517,
            -789517,
            -1184275,
            -1184275,
            -1644826,
            -1644826,
            -2039584,
            -2039584,
            -2434342,
            -2434342,
            -2434342,
            -2829100,
            -2829100,
            -3158065,
            -3158065,
            -3552823,
            -3552823,
            -3552823
        )
        visiblePalette = FixedPalette(
            -5329234,
            -5329234,
            -5658199,
            -5658199,
            -5658199,
            -5987164,
            -5987164,
            -6316129,
            -6316129,
            -6645094,
            -6645094,
            -6645094,
            -6908266,
            -6908266,
            -7105645,
            -7105645,
            -7237231,
            -7237231,
            -7237231,
            -7500403,
            -7500403,
            -7829368,
            -7829368,
            -8092540,
            -8092540,
            -8355712,
            -8355712,
            -8355712,
            -8618884,
            -8618884,
            -8882056,
            -8882056,
            -9145228,
            -9145228,
            -9145228,
            -9408400,
            -9408400,
            -9671572,
            -9671572,
            -9737365,
            -9737365,
            -9737365,
            -9934744,
            -9934744,
            -10132123,
            -10132123,
            -10395295,
            -10395295,
            -10592674,
            -10592674,
            -10592674,
            -10790053,
            -10790053,
            -11053225,
            -11053225,
            -11250604,
            -11250604,
            -11250604,
            -11447983,
            -11447983,
            -11645362,
            -11645362,
            -11776948,
            -11776948,
            -11776948,
            -11842741,
            -11842741,
            -12040120,
            -12040120,
            -12237499,
            -12237499,
            -12369085,
            -12369085,
            -12369085,
            -12566464,
            -12566464,
            -12763843,
            -12763843,
            -12895429,
            -12895429,
            -12895429,
            -13092808,
            -13092808,
            -13224394,
            -13224394,
            -13355980,
            -13355980,
            -13355980,
            -13421773,
            -13421773,
            -13553359,
            -13553359,
            -13684945,
            -13684945,
            -13750738,
            -13750738,
            -13750738,
            -13816531,
            -13816531,
            -13948117,
            -13948117,
            -14079703,
            -14079703,
            -14079703,
            -14211289,
            -14211289,
            -14342875,
            -14342875,
            -14474461,
            -14474461,
            -14474461,
            -14540254,
            -14540254,
            -14671840,
            -14671840,
            -14671840,
            -14671840,
            -14671840,
            -14803426,
            -14803426,
            -14869219,
            -14869219,
            -15000805,
            -15000805,
            -15066598,
            -15066598,
            -15066598,
            -15198184,
            -15198184,
            -15263977
        )
        selectedPalette = FixedPalette(
            selection.brightenAndSaturate(0.0f, -0.2f),
            selection.brightenAndSaturate(0.0f, -0.1f),
            selection,
            selection.brightenAndSaturate(-0.1f, 0.0f),
            selection.brightenAndSaturate(-0.2f, 0f)
        )
        selectedShadowPalette = FixedPalette(selection.brightenAndSaturate(0.0f, -0.8f))
    }
}
